
import React from 'react';
import { Link } from 'react-router-dom';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Twitter, Facebook, Instagram, Send, Youtube } from 'lucide-react';
import { WaveDivider } from '../Animations';

const LandingFooter: React.FC = () => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Implementation for email subscription would go here
  };

  const quickLinks = [
    { name: 'Search', path: '/search' },
    { name: 'FAQ', path: '/faq' },
    { name: 'Contact Us', path: '/contact' },
    { name: 'For Couples', path: '/for-couples' },
    { name: 'Privacy Policy', path: '/privacy-policy' },
    { name: 'Refund Policy', path: '/refund-policy' },
    { name: 'Terms of Service', path: '/terms-of-service' },
  ];

  return (
    <footer className="bg-white text-hormony-charcoal relative pt-16 pb-8">
      <WaveDivider position="top" color="#F9F5F0" className="absolute top-0 left-0 w-full" />
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 pb-8">
          {/* Quick links */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Quick links</h3>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path} 
                    className="hover:underline hover:text-hormony-coral transition-colors"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Middle column - can be used for additional content */}
          <div className="hidden lg:block">
            {/* Intentionally left empty for spacing */}
          </div>
          
          {/* Subscribe section */}
          <div>
            <h3 className="text-xl font-semibold mb-4">Subscribe to emails</h3>
            <p className="mb-4">Be the first to hear about sales and new offerings! 💌</p>
            
            <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-2">
              <Input 
                type="email" 
                placeholder="Enter email" 
                className="bg-white/20 border-hormony-charcoal/30 placeholder:text-hormony-charcoal/70 text-hormony-charcoal"
                required
              />
              <Button type="submit" variant="secondary" className="bg-[#E27D60] text-white hover:bg-[#E27D60]/90">
                <Send size={20} />
              </Button>
            </form>
            
            {/* Social links - updated with proper hrefs */}
            <div className="flex justify-end mt-6 space-x-4">
              <a href="https://twitter.com/findhormony" target="_blank" rel="noopener noreferrer" className="text-hormony-charcoal hover:text-hormony-coral transition-colors" aria-label="Twitter">
                <Twitter size={20} />
              </a>
              <a href="https://facebook.com/findhormony" target="_blank" rel="noopener noreferrer" className="text-hormony-charcoal hover:text-hormony-coral transition-colors" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://instagram.com/findhormony" target="_blank" rel="noopener noreferrer" className="text-hormony-charcoal hover:text-hormony-coral transition-colors" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="https://tiktok.com/@findhormony" target="_blank" rel="noopener noreferrer" className="text-hormony-charcoal hover:text-hormony-coral transition-colors" aria-label="TikTok">
                {/* Replaced Tiktok with a custom SVG icon for TikTok */}
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 12a4 4 0 1 0 4 4V4a5 5 0 0 0 5 5" />
                </svg>
              </a>
              <a href="https://youtube.com/@findhormony" target="_blank" rel="noopener noreferrer" className="text-hormony-charcoal hover:text-hormony-coral transition-colors" aria-label="YouTube">
                <Youtube size={20} />
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-hormony-charcoal/20 pt-6 mt-4">
          <p className="text-sm text-hormony-charcoal/70 text-center">
            © {new Date().getFullYear()} Hormonal Harmony. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
